import { PlusOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";

import styles from "./AddFieldMappingDropdown.module.scss";

import { EntityMetadata } from "../../types/entityMetadata";
import { ImportConfiguration } from "../../types/importConfiguration";

interface AddFieldMappingDropdownProps {
    destinationMetadataData: EntityMetadata[];
    importConfiguration: ImportConfiguration;
    handleAddFieldMapping: (fieldIdentifier: string) => void;
}
export const AddFieldMappingDropdown = ({
    destinationMetadataData,
    importConfiguration,
    handleAddFieldMapping
}:AddFieldMappingDropdownProps) => {
    const { destinationIdentifier } = importConfiguration;
    const reportMetaData = destinationMetadataData.find((item) => item.identifier === destinationIdentifier);
    const properties = reportMetaData ? reportMetaData.properties : [];
    const options = properties.map((item) => ({
        label: <div>{item.displayName}</div>,
        key: item.identifier,
    }));

    const handleSelect = ({ key }: { key: string}) => {
        handleAddFieldMapping(key);
    }

    return (
        <Dropdown
            className={styles.root}
            trigger={["click"]}
            menu={{ items: options, onClick: handleSelect}}
        >
            <Space className={styles.trigger}><PlusOutlined />Add field mapping</Space>
        </Dropdown>  
    )
}